import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Stack, Typography, CircularProgress, Button } from '@mui/material';
import { getBearerToken } from '../../utils/Apis';
import MeetingRoom from './MeetingRoom';
import IosJoinGate from './IosJoinGate';
import { isIOS } from './iosFallback';

/**
 * Participant joins their assigned room from a browser.
 * Route: /meeting/join  (logged-in User / Participant)
 */
export default function JoinMeeting() {
  const navigate = useNavigate();
  const [state, setState] = useState('loading'); // loading | ios | ready | error
  const [creds, setCreds] = useState(null);
  const [error, setError] = useState('');
  const [forceBrowser, setForceBrowser] = useState(false);

  useEffect(() => {
    (async () => {
      const r = await getBearerToken('web_join_meeting');
      if (r && r.error === 0) {
        setCreds(r);
        setState(isIOS() ? 'ios' : 'ready');
      } else {
        setError((r && r.status) || 'Could not join the meeting.');
        setState('error');
      }
    })();
  }, []);

  if (state === 'loading') {
    return (
      <Box sx={{ position: 'fixed', inset: 0, bgcolor: '#0b1020', display: 'grid', placeItems: 'center' }}>
        <Stack alignItems="center" spacing={2}><CircularProgress sx={{ color: '#38bdf8' }} /><Typography sx={{ color: '#94a3b8' }}>Joining…</Typography></Stack>
      </Box>
    );
  }
  if (state === 'error') {
    return (
      <Box sx={{ position: 'fixed', inset: 0, bgcolor: '#0b1020', display: 'grid', placeItems: 'center', p: 3 }}>
        <Stack alignItems="center" spacing={2} sx={{ textAlign: 'center', maxWidth: 420 }}>
          <Typography variant="h6" sx={{ color: '#fff' }}>Can’t join</Typography>
          <Typography sx={{ color: '#f87171' }}>{error}</Typography>
          <Button variant="contained" onClick={() => navigate('/login')}>Back</Button>
        </Stack>
      </Box>
    );
  }
  if (state === 'ios' && !forceBrowser) {
    return <IosJoinGate roomName={creds.room_name} meetingNumber={creds.meeting_number} password={creds.password} onBrowserAnyway={() => setForceBrowser(true)} />;
  }
  return <MeetingRoom creds={creds} isHost={false} roomName={creds.room_name} onLeave={() => navigate('/login')} />;
}
